<template>
  <!--
    	作者：kmdshop
    	时间：2019-10-26
    	描述：商品管理-商品编辑-规格/库存-多规格
    -->
  <div>
    <!-- <div style="display: flex;">
      <div style="flex:1.5;"></div>
      <div v-if="specData!=null" style="margin: 20rpx;width: 70%;flex:8.5;"> 
        暂未支持SKU规格修改，新增未影响，敬请期待
      </div>
    </div> -->
    
    <!--规格类别-->
    <Type :specData="specData"></Type>

    <!--规定表格显示-->
    <Table :specData="specData"></Table>
  </div>
</template>

<script>
import Type from './many/Type.vue';
import Table from './many/Table.vue';
export default {
  components: {
    /*规格类别属性*/
    Type,
    /*规格表格*/
    Table
  },
  props:["specData"]
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/product/part/spec/Many.vue